import { card, label } from "./_genCommon";

/** Generic table renderer for Generative Design data tabs (BOQ, Equipment List,
 * Area Statement, Unit Mix, Cost Breakdown, Structure Schedule, etc.).
 * Reads {title, columns:[{key,label}], rows:[{}], summary?:[{label,value}]}.
 */
export default function DataTabView({ data }) {
  if (!data) return <div style={{ padding: 24, color: "var(--pf-muted)" }}>Loading…</div>;
  const { title, columns = [], rows = [], summary = [] } = data;
  return (
    <div data-testid="gen-data-tab" style={{ padding: 12 }}>
      <div style={{ fontSize: 14, fontWeight: 700, color: "#F26B1F",
                          marginBottom: 8 }}>
        {title}
      </div>
      {summary.length > 0 && (
        <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 12 }}>
          {summary.map((s, i) => (
            <div key={i} style={{ ...card, padding: 8, minWidth: 130 }}>
              <div style={{ ...label, fontSize: 9 }}>{s.label}</div>
              <div style={{ fontSize: 16, fontWeight: 700, color: "#F26B1F",
                                  marginTop: 2 }}>
                {s.value}
              </div>
            </div>
          ))}
        </div>
      )}
      {rows.length === 0
        ? <div style={{ padding: 24, color: "var(--pf-muted)", fontSize: 12 }}>
            No data yet for this view.
          </div>
        : <div style={{ ...card, padding: 0, overflow: "auto" }}>
            <table data-testid="gen-data-table"
                style={{ width: "100%", fontSize: 11, borderCollapse: "collapse" }}>
              <thead style={{ background: "#0F131C" }}>
                <tr>
                  {columns.map(c => (
                    <th key={c.key} style={{
                        textAlign: typeof rows[0]?.[c.key] === "number" ? "right" : "left",
                        padding: "8px 10px", color: "#F26B1F",
                        borderBottom: "2px solid #F26B1F",
                        fontWeight: 600 }}>
                      {c.label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rows.map((r, i) => (
                  <tr key={i} style={{
                      background: i % 2 === 0 ? "transparent" : "rgba(255,255,255,0.02)",
                      borderBottom: "1px solid var(--pf-border)" }}>
                    {columns.map(c => {
                      const val = r[c.key];
                      const isNum = typeof val === "number";
                      return (
                        <td key={c.key} style={{
                            padding: "6px 10px",
                            textAlign: isNum ? "right" : "left",
                            fontFamily: isNum ? "ui-monospace, Menlo, monospace" : "inherit",
                            color: val === undefined || val === "—"
                              ? "var(--pf-muted)" : "var(--pf-text)" }}>
                          {isNum ? val.toLocaleString() : (val ?? "—")}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>}
    </div>
  );
}
